export const checkIfStartTimeEarlyThanEndTime = (startTime: string, endTime: string): boolean => {
  if (startTime.length <= 0 || endTime.length <= 0) return false;
  const dtStartTime = new Date('2022-01-01 ' + startTime);
  const dtEndTime = new Date('2022-01-01 ' + endTime);
  const diffInMilliseconds = dtEndTime.getTime() - dtStartTime.getTime();
  if (diffInMilliseconds < 0) return false;
  else return true;
};
